import React, { useCallback, useEffect, useState } from "react";
import useTabs from "../hooks/useTabs";
import Setting from "../components/Setting/Setting";
import * as apis from "../apis";

export default function SettingContainer() {
  const tabButtons = [
    { id: 1, tab: "한국어", locale: "ko" },
    { id: 2, tab: "영문", locale: "en" },
  ];
  const { currentItem, changeItem } = useTabs(0, tabButtons);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const res = await apis.getCompanyInfo(currentItem.locale);
        setForm(res?.data?.data);
      } catch (error) {
        console.error(error);
        alert(
          error.response?.data?.message ||
            "회사 정보를 불러오는데 실패 하였습니다."
        );
      }
    };
    fetchCompanyInfo();
  }, [currentItem.locale]);

  const [form, setForm] = useState({
    businessName: "",
    ceoName: "",
    address: "",
    privacyManager: "",
    businessNumber: "",
    phoneNumber: "",
    locale: currentItem.locale,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = useCallback(async () => {
    if (!form.businessName.trim()) {
      alert("상호명을 입력해주세요.");
      return;
    }
    if (!form.ceoName.trim()) {
      alert("대표자를 입력해주세요.");
      return;
    }
    if (!form.address.trim()) {
      alert("주소를 입력해주세요.");
      return;
    }
    if (!form.privacyManager.trim()) {
      alert("개인정보처리 책임자를 입력해주세요.");
      return;
    }
    if (!form.businessNumber.trim()) {
      alert("사업자등록번호를 입력해주세요.");
      return;
    }
    try {
      if (window.confirm("회사 정보를 저장하시겠습니까?")) {
        await apis.updateCompanyInfo(form);
        const message =
          form.locale === "ko"
            ? "한국어 회사정보가 저장되었습니다."
            : "영문 회사정보가 저장되었습니다.";

        alert(message);
      }
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "회사 정보를 저장하는데 실패 하였습니다."
      );
    }
  }, [form]);

  return (
    <Setting
      tabButtons={tabButtons}
      currentItem={currentItem}
      form={form}
      changeItem={changeItem}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
}
